import script from "./ProgressViewLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressViewLoader.vue?vue&type=script&setup=true&lang=js"

import "./ProgressViewLoader.vue?vue&type=style&index=0&id=2be2c7c0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be2c7c0"]])

export default __exports__